import { maxFileBytes, megabytesLabel } from "@/lib/uploadLimits"
/**
 * What the appeal workspace accepts as a document, checked BEFORE upload by
 * every entry point (the intake and "Add document" on the draft): the
 * extraction service reads PDF and Word only, and the API proxy refuses a
 * body over 25 MB (nginx client_max_body_size). A file that fails either
 * check would otherwise upload for a while and then fail at the proxy with a
 * generic error, after the officer has moved on.
 */

export const ACCEPTED_TYPES: readonly string[] = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
]
export const ACCEPTED_EXT = /\.(pdf|docx?)$/i
/** One MB under the proxy's 25 MB limit, for the multipart envelope. */
export const MAX_UPLOAD_BYTES = 24 * 1024 * 1024
/** The `accept` attribute for file inputs (a hint to the picker; the check below is the rule). */
export const ACCEPT_ATTR = ".pdf,.doc,.docx,application/pdf"

export interface ScreenedFiles {
  accepted: File[]
  /** One line per refused file: its name and why. */
  rejected: string[]
}

export function screenUploads(files: Iterable<File>): ScreenedFiles {
  const accepted: File[] = []
  const rejected: string[] = []
  for (const file of files) {
    if (!ACCEPTED_TYPES.includes(file.type) && !ACCEPTED_EXT.test(file.name)) {
      rejected.push(`${file.name}: only PDF or Word files can be read`)
    } else if (file.size > maxFileBytes(MAX_UPLOAD_BYTES)) {
      rejected.push(`${file.name}: larger than ${megabytesLabel(maxFileBytes(MAX_UPLOAD_BYTES))} — split or compress it`)
    } else {
      accepted.push(file)
    }
  }
  return { accepted, rejected }
}
